// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --volume-slider-height: 8px;
    --volume-slider-fill-color: var(--highlight-bg-color-hover);
    --volume-slider-empty-color: #AAA;
}

.button-plugin-side-area.volume-button {
    height: 40px;
    display: inline-block;
    vertical-align: middle;
}

.button-plugin-container {
    height: 40px;
}

.volume-slider {
    width: 100px;
    height: 100%;
    display: flex;
    margin-left: 10px;
    margin-right: 10px;
    position: relative;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.volume-slider .volume-slider-fill {
    height: var(--volume-slider-height);
    background-color: var(--volume-slider-fill-color);
    border-radius: 10px 0px 0px 10px;
    pointer-events: none;
}

.volume-slider .volume-slider-fill.fill-100 {
    border-radius: 10px 10px 10px 10px;
}

.volume-slider .volume-slider-empty {
    height: var(--volume-slider-height);
    background-color: var(--volume-slider-empty-color);
    border-radius: 0px 10px 10px 0px;
    pointer-events: none;
}

.volume-slider .volume-slider-empty.empty-100 {
    border-radius: 10px 10px 10px 10px;
}

@media (forced-colors: active) {
    .volume-slider {
        border: 4px solid white;
        box-sizing: border-box;
        margin-bottom: 3px;
    }

    .volume-slider .volume-slider-fill {
        border: 4px solid white;
        box-sizing: border-box;
    }

    .volume-slider .volume-slider-empty {
        border: 1px solid white;
        box-sizing: border-box;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Slider.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,2DAA2D;IAC3D,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,iDAAiD;IACjD,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;IACnC,kDAAkD;IAClD,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;QACvB,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;AACJ","sourcesContent":[":root {\n    --volume-slider-height: 8px;\n    --volume-slider-fill-color: var(--highlight-bg-color-hover);\n    --volume-slider-empty-color: #AAA;\n}\n\n.button-plugin-side-area.volume-button {\n    height: 40px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.button-plugin-container {\n    height: 40px;\n}\n\n.volume-slider {\n    width: 100px;\n    height: 100%;\n    display: flex;\n    margin-left: 10px;\n    margin-right: 10px;\n    position: relative;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.volume-slider .volume-slider-fill {\n    height: var(--volume-slider-height);\n    background-color: var(--volume-slider-fill-color);\n    border-radius: 10px 0px 0px 10px;\n    pointer-events: none;\n}\n\n.volume-slider .volume-slider-fill.fill-100 {\n    border-radius: 10px 10px 10px 10px;\n}\n\n.volume-slider .volume-slider-empty {\n    height: var(--volume-slider-height);\n    background-color: var(--volume-slider-empty-color);\n    border-radius: 0px 10px 10px 0px;\n    pointer-events: none;\n}\n\n.volume-slider .volume-slider-empty.empty-100 {\n    border-radius: 10px 10px 10px 10px;\n}\n\n@media (forced-colors: active) {\n    .volume-slider {\n        border: 4px solid white;\n        box-sizing: border-box;\n        margin-bottom: 3px;\n    }\n\n    .volume-slider .volume-slider-fill {\n        border: 4px solid white;\n        box-sizing: border-box;\n    }\n\n    .volume-slider .volume-slider-empty {\n        border: 1px solid white;\n        box-sizing: border-box;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
